var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.clientFormData)?_c('client-form',{attrs:{"title":_vm.title,"submit-button-text":_vm.submitButtonText,"client-form-data":_vm.clientFormData},on:{"submitClientForm":function($event){return _vm.onSubmit($event)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }